<template>
  <v-container
    class="ma-0 pa-0"
  >
    <v-row
      class="ma-0 pa-0"
    >
      <!--ここから。結果表示欄-->
      <v-col
        cols="6"
        class="ma-0 pa-1"
      >
        <v-card
          class="ma-0 pa-0 overflow-y-auto"
          style="height:87vh;"
        >
          <v-list
            v-for="(item, index) in dspList"
            :key="`${index}-${item}`"
            class="ma-1 pa-0"
            min-height="25px"
            v-text="item"
          />
        </v-card>
      </v-col>
      <!--ここまで。結果表示欄-->
      <v-col
        cols="6"
        class="ma-0 pa-1"
      >
        <v-card
          class="ma-0 pa-0 overflow-y-auto"
          style="height:87vh;"
        >
          <v-tabs
            v-model="editTabs"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
            fixed-tabs
            class="fixed-bar"
          >
            <v-tabs-slider />
            <v-tab :href="'#edit-type-1'">
              編集
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="editTabs">
            <v-tab-item
              :value="'edit-type-1'"
              class="ma-0 pa-2"
            >
              <v-chip
                class="ma-1"
                color="success"
                outlined
              >
                <v-icon left>
                  mdi-information-outline
                </v-icon>
                拒絶理由通知
              </v-chip>
              <br>※（テスト段階の機能）サンプルボタンで試行可能
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    small
                    outlined
                    color="primary"
                    class="mb-3 pa-0"
                    v-bind="attrs"
                    v-on="on"
                    @click="eliminateNewline()"
                  >
                    拒絶整形
                  </v-btn>
                </template>
                <span>半角の空白を削除し、不要な改行を削除します。</span>
              </v-tooltip>
              <v-row>
                <v-col
                  cols="5"
                  class="ma-0 pa-0 pl-4 pt-2"
                  style="font-size: 12px;"
                >
                  削除対象の改行<br>文頭から：
                </v-col>
                <v-col
                  cols="3"
                  class="ma-0 pa-0 pt-1 pl-0"
                >
                  <v-text-field
                    v-model="characterNumFrom"
                    label="文字以上"
                  />
                </v-col>
                <v-col
                  cols="3"
                  class="ma-0 pa-0 pt-1 pr-0"
                >
                  <v-text-field
                    v-model="characterNumTo"
                    label="文字未満"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  export default {
    data: () => ({
      editTabs: null,
      dspList: '',
      isZenkiOKDsp: false,
      testapi: 'block',
      characterNumFrom: 33,
      characterNumTo: 37,
    }),

    methods: {

      eliminateNewline () {
        let splitNewline = this.$store.state.memNowDoc.replace(/ /g, '').split(/\n|\r\n|\r|P.*/g)
        splitNewline = splitNewline.filter(word => word.length > 0)
        splitNewline = splitNewline.map((value, index, array) => {
          if (index !== array.length - 1) {
            if (/^\s/.test(array[index + 1]) === true) return value + '<br>'
          }
          if (value.length <= this.characterNumTo && value.length > this.characterNumFrom && !/\s$/.test(value) && !/。$/.test(value)) return value
          else return value + '<br>'
        })
        this.$store.commit('changeEdtorHTML', splitNewline.join(''))
      },
    },
  }
</script>

<style>
.fixed-bar {
    position: sticky;
    position: -webkit-sticky; /* for Safari */
    top: 0em;
    z-index: 1;
}
</style>
